import React from "react";
import { TrackingObject } from "@themuse/design-system/lib/types/TrackingTypes";

import { ButtonGroup, MultiSelectButtonGroup, ButtonGroupProps } from "./JobQuizInputs";

import styles from "./JobQuizContainer.module.scss";

interface QuestionResponse {
    questionId: string;
    questionOrder?: number;
    field?: string;
    response?: any;
}

interface ButtonOption {
    id?: number;
    display?: string;
    value: string;
}

interface JobQuizQuestionProps {
    questionId: string;
    field?: string;
    fieldType: string;
    flow?: boolean;
    title: string;
    details?: string;
    options: ButtonOption[];
    extraClass?: string;
    trackingData?: TrackingObject;
    clickTrackingData?: TrackingObject;
    onResponseChange?: (value: any) => void;
}

/**
 * Renders a question in the job quiz.
 */
const JobQuizQuestion = (props: JobQuizQuestionProps & React.HTMLProps<HTMLDivElement>) => {
    const {
        details,
        field,
        fieldType,
        flow,
        options,
        title,
        questionId,
        extraClass,
        clickTrackingData,
        onResponseChange
    } = props;

    const handleSelect = (selections: string[]) => {
        const questionData: QuestionResponse = {
            questionId,
            response: selections
        };
        if (field) {
            questionData.field = field;
        }
        onResponseChange?.(questionData);
    };

    const inputComponent = () => {
        const inputProps: ButtonGroupProps = {
            field,
            flow,
            choices: options,
            onSelect: handleSelect
        };

        let Component = null;
        switch (fieldType) {
        case "multiSelectButtonGroup":
            Component = <MultiSelectButtonGroup {...inputProps} clickTrackingData={clickTrackingData} />;
            break;
        default:
            Component = <ButtonGroup {...inputProps} clickTrackingData={clickTrackingData} />;
            break;
        }

        return Component;
    };

    return (
        <div className={[styles.contentBody, extraClass].join(" ")}>
            <p className={styles.title}>{title}</p>
            <p className={styles.details}>{details}</p>

            <div className={styles.inputs}>
                {inputComponent()}
            </div>
        </div>
    );
};
JobQuizQuestion.displayName = "JobQuizQuestion";

export { JobQuizQuestion as default };
export type { JobQuizQuestionProps };
export type { QuestionResponse };
